/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';

import { CTA, FluidImageType, ReactSpringHook } from 'utils/types';
import BackgroundImage from './BackgroundImage';
import SecondaryCTASection from '../SecondaryCTASection';

import * as S from './styles';

export interface Props {
  backgroundImage: FluidImageType;
  mobileBackgroundImage?: FluidImageType;
  backgroundColor?: string;
  secondaryHeadline?: string;
  secondaryCtaList?: CTA[];
  /* center the content of the hero vertically */
  verticalCenter?: boolean;
  children: JSX.Element;
  /* ref object for orchestrating animations from the template*/
  bgTransitionRef: React.RefObject<ReactSpringHook>;
  /* ref object for orchestrating animations from the template*/
  contentTransitionRef: React.RefObject<ReactSpringHook>;
}

/**
 * Base Hero component - renders the background image and children, handles animating the background image and content
 */
export const BaseHero: React.FC<Props> = ({
  backgroundColor,
  backgroundImage,
  mobileBackgroundImage,
  secondaryHeadline,
  secondaryCtaList,
  verticalCenter,
  children,
}) => {
  return (
    <S.Section
      data-testid="hero"
      backgroundColor={backgroundColor}
      verticalCenter={verticalCenter}
    >
      <S.InnerSection>
        {backgroundImage ? (
          <BackgroundImage
            fluidImage={backgroundImage}
            mobileFluidImage={mobileBackgroundImage}
            verticalCenter={verticalCenter}
          />
        ) : null}
        <S.InnerContent>{children}</S.InnerContent>
      </S.InnerSection>
      {secondaryCtaList && secondaryHeadline ? (
        <SecondaryCTASection
          secondaryCtaList={secondaryCtaList}
          secondaryHeadline={secondaryHeadline}
        />
      ) : null}
    </S.Section>
  );
};

export default BaseHero;
